<template>
	<div>
		<!-- Page Header -->
		<div class="d-flex justify-space-between align-center mb-3">
			<h3 class="text-h4 font-weight-light">Products</h3>

			<div class="d-inline-flex align-center">
				<div v-if="search['show']" class="d-inline-block mr-3">
					<v-text-field class="fsk-v-input" v-model="search['input']" name="search" type="search" dense hide-details="auto" prepend-inner-icon="mdi-magnify" outlined clearable></v-text-field>
				</div>
				<v-btn v-if="!search['show']" icon :small="!$vuetify.breakpoint.lgAndUp" color="grey" @click="search['show'] = true"><v-icon>mdi-magnify</v-icon></v-btn>
				<v-btn icon :small="!$vuetify.breakpoint.lgAndUp" color="grey" @click.stop="showForm"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
				<v-btn icon :small="!$vuetify.breakpoint.lgAndUp" color="grey" @click="resetTable()"><v-icon>mdi-cached</v-icon></v-btn>
			</div>
		</div>

		<!-- Page Body -->
		<div>
			<v-card :loading="loading" v-if="!reset">
				<v-card-text>
					<v-data-table
						class="fsk-v-data-table"
						:headers="headers"
						:items="table"
						:search="search['input']"
					>
						<template v-slot:[`item.name`]="{ item }">
							<div class="py-3">
								<div>{{ item['name'] }}</div>
								<div class="caption">{{ item['code'] }}</div>
							</div>
						</template>
						<template v-slot:[`item.status`]="{ item }">
							<div class="text-center">
								<v-chip :color="getStatusColor(item.status)" x-small outlined>{{ item['status'] }}</v-chip>
							</div>
						</template>
						<template v-slot:[`item.date`]="{ item }">
							<div>{{ $moment.utc(item['date']).format('DD MMM YYYY') }}</div>
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<div class="v-data-table-actions">
								<v-menu bottom left>
									<template v-slot:activator="{ on, attrs }">
									<v-btn icon v-bind="attrs" v-on="on">
										<v-icon>mdi-dots-horizontal</v-icon>
									</v-btn>
									</template>

									<v-list>
									<v-list-item dense @click="editItem(item)">
										<v-list-item-title>View / Edit</v-list-item-title>
									</v-list-item>
									<v-list-item dense @click="updateStatus(item)">
										<v-list-item-title>Update Status</v-list-item-title>
									</v-list-item>
									<v-list-item dense @click="deleteItem(item)">
										<v-list-item-title>Delete</v-list-item-title>
									</v-list-item>
									</v-list>
								</v-menu>
							</div>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</div>

		<!-- Create Dialog -->
		<v-dialog
			v-model="form['show']"
			persistent
			scrollable
			content-class="fsk-v-create-dialog"
		>
			<v-card :loading="form['loading']" :disabled="form['loading']">
				<v-card-title>
					<span v-if="form['create']" class="headline">New Product</span>
					<span v-else class="headline">Edit Product</span>
				</v-card-title>
				<v-card-text style="max-height: 80vh;">
					<v-row>
						<v-col cols="12" md="6">
							<v-dialog ref="dialogDate" v-model="modal['date']" :return-value.sync="form['data']['date']" persistent width="290px">
								<template v-slot:activator="{ on, attrs }">
								<v-text-field :value="$moment.utc(form['data']['date']).format('DD MMM YYYY')" class="fsk-v-input" label="W.E.F *" name="date" readonly outlined dense hide-details="auto" v-bind="attrs" v-on="on"></v-text-field>
								</template>
								<v-date-picker v-model="form['data']['date']" scrollable @input="$refs.dialogDate.save(form['data']['date'])">
								</v-date-picker>
							</v-dialog>
						</v-col>
						<v-col cols="12" md="6"></v-col>
						<v-col cols="12" md="6">
							<v-text-field v-model="form['data']['name']" class="fsk-v-input" label="Name *" name="name" type="text" outlined dense hide-details="auto"></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field v-model="form['data']['code']" class="fsk-v-input" label="Code *" name="code" type="text" outlined dense hide-details="auto"></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-select v-model="form['data']['vendor']" class="fsk-v-input" :items="['Dell', 'HP', 'Sony', 'Adidas', 'Lync', 'Crazy Egg']" label="Vendor *" name="vendor" outlined dense hide-details="auto"></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-select v-model="form['data']['category']" class="fsk-v-input" :items="['Automotive', 'Beauty', 'Clothing', 'Books', 'Entertainment', 'Electronics', 'Grocery & Gourmet Foods', 'Health & Personal Care', 'Jewellery', 'Sports']" label="Category *" name="category" outlined dense hide-details="auto"></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field v-model="form['data']['cost']" class="fsk-v-input" label="Cost *" name="cost" type="text" outlined dense hide-details="auto"></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field v-model="form['data']['stock']" class="fsk-v-input" label="Stock *" name="stock" type="text" outlined dense hide-details="auto"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4 px-6">
					<v-spacer></v-spacer>
					<v-btn color="grey" text @click="hideForm()">Close</v-btn>
					<v-btn color="primary" text @click="submitForm()">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Status Dialog -->
		<v-dialog
			v-model="tag['show']"
			persistent
			max-width="400"
		>
		<v-card :loading="tag['loading']" :disabled="tag['loading']">
			<v-card-title class="headline">Update Status</v-card-title>

			<v-card-text style="max-height: 80vh;">
				<v-row>
					<v-col cols="12">
						<v-select v-model="tag['status']" class="fsk-v-input" :items="['In Stock', 'Low Stock', 'Ordered']" label="Status *" name="status" outlined dense :color="getStatusColor(tag['status'])" hide-details="auto"></v-select>
					</v-col>
				</v-row>
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions class="py-4 px-6">
				<v-spacer></v-spacer>
				<v-btn color="grey" text @click="hideStatus()">Close</v-btn>
				<v-btn color="primary" text @click="confirmStatus()">Save</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>

		<!-- Delete Dialog -->
		<v-dialog
			v-model="del['show']"
			persistent
			max-width="400"
		>
		<v-card :loading="del['loading']" :disabled="del['loading']">
			<v-card-title class="headline">Delete Product</v-card-title>

			<v-card-text>Please confirm the deletion of product <strong>{{ del['name'] }}</strong></v-card-text>

			<v-divider></v-divider>
			<v-card-actions class="py-4 px-6">
				<v-spacer></v-spacer>
				<v-btn color="grey" text @click="hideDelete()">Close</v-btn>
				<v-btn color="primary" text @click="confirmDelete()">Confirm</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		data: () => ({
			modal: {
				date: false
			},
			search: {
				show: false,
				input: ''
			},
			loading: false,
			reset: false,
			headers: [
				{
					text: 'Name',
					align: 'start',
					value: 'name',
				},
				{
					text: 'Vendor',
					value: 'vendor',
				},
				{
					text: 'Category',
					value: 'category',
				},
				{
					text: 'Cost',
					value: 'cost',
				},
				{
					text: 'W.E.F',
					value: 'date',
				},
				{
					text: 'Stock',
					value: 'stock',
				},
				{
					text: 'Status',
					value: 'status',
					align: 'center',
				},
				{ text: 'Actions', align: 'end', value: 'actions', sortable: false },
			],
			table: [],
			form: {
				create: true,
				show: false,
				loading: false,
				data: {
					id: '',
					date: '',
					name: '',
					code: '',
					vendor: '',
					category: '',
					cost: '',
					stock: '',
					status: '',
				}
			},
			tag: {
				show: false,
				loading: false,
				id: '',
				status: ''
			},
			del: {
				show: false,
				loading: false,
				id: '',
				name: ''
			}
		}),

		created() {
			this.initialize();
		},

		methods: {
			initialize () {
				this.table = [
					{
						id: 1,
						name: 'Alienware M15',
						code: 'P00825',
						vendor: 'Dell',
						category: 'Electronics',
						cost: '2,50,000',
						stock: '5,000',
						status: 'In Stock',
						date: new Date()
					},
					{
						id: 2,
						name: 'Playstation 5',
						code: 'P00843',
						vendor: 'Sony',
						category: 'Entertainment',
						cost: '50,000',
						stock: '500',
						status: 'Ordered',
						date: new Date(Date.now() - 86400000)
					},
					{
						id: 3,
						name: 'Merc Hoodie',
						code: 'P00090',
						vendor: 'Lync',
						category: 'Clothing',
						cost: '2,000',
						stock: '65,000',
						status: 'In Stock',
						date: new Date(Date.now() - 3888000000)
					},
					{
						id: 4,
						name: 'JJ Dashboard Figurine',
						code: 'P00345',
						vendor: 'Crazy Egg',
						category: 'Automotive',
						cost: '500',
						stock: '50',
						status: 'Low Stock',
						date: new Date(Date.now() - 6480000000)
					},
					{
						id: 5,
						name: 'Optical Mouse',
						code: 'P00010',
						vendor: 'HP',
						category: 'Electronics',
						cost: '5,000',
						stock: '1,000',
						status: 'Ordered',
						date: new Date(Date.now() - 7344000000)
					},
				]
			},
			resetTable() {
				this.loading = true;

				setTimeout(() => {
					this.loading = false;
					this.reset = true;
					this.reset = false;
				}, 3000);
			},
			getStatusColor (status) {
				switch (status) {
					case 'Ordered':
						return 'orange'
					
					case 'In Stock':
						return 'success'
					
					case 'Low Stock':
						return 'red'
			
					default:
						return 'grey'
				}
			},
			editItem(item) {
				// Assign form data
				this.form['data']['id'] = item['id'];
				this.form['data']['date'] = item['date'];
				this.form['data']['name'] = item['name'];
				this.form['data']['code'] = item['code'];
				this.form['data']['vendor'] = item['vendor'];
				this.form['data']['category'] = item['category'];
				this.form['data']['cost'] = item['cost'];
				this.form['data']['stock'] = item['stock'];
				this.form['data']['status'] = item['status'];

				// Show dialog
				this.showForm('edit');
			},
			updateStatus(item) {
				// Assign data
				this.tag['id'] = item['id'];
				this.tag['status'] = item['status'];

				// Show dialog
				this.tag['show'] = true;
			},
			hideStatus() {
				// Reset data
				this.tag['id'] = '';
				this.tag['status'] = '';

				// Unset loading
				this.tag['loading'] = false;

				// Hide dialog
				this.tag['show'] = false;
			},
			confirmStatus() {
				// TODO: Add update status API
				console.log(this.tag['id']);

				// Set loading
				this.tag['loading'] = true;

				setTimeout(() => {
					// Hide dialog
					this.hideStatus();
				}, 3000);
			},
			deleteItem(item) {
				// Assign data
				this.del['id'] = item['id'];
				this.del['name'] = item['name'];

				// Show dialog
				this.del['show'] = true;
			},
			hideDelete() {
				// Reset data
				this.del['id'] = '';
				this.del['name'] = '';

				// Unset loading
				this.del['loading'] = false;

				// Hide dialog
				this.del['show'] = false;
			},
			confirmDelete() {
				// TODO: Add delete product API
				console.log(this.del['id']);

				// Set loading
				this.del['loading'] = true;

				setTimeout(() => {
					// Hide dialog
					this.hideDelete();
				}, 3000);
			},
			resetForm() {
				this.form['data']['id'] = '';
				this.form['data']['date'] = '';
				this.form['data']['name'] = '';
				this.form['data']['code'] = '';
				this.form['data']['vendor'] = '';
				this.form['data']['category'] = '';
				this.form['data']['cost'] = '';
				this.form['data']['stock'] = '';
				this.form['data']['status'] = '';
			},
			showForm(type = 'create') {
				if (type == 'edit') {
					this.form['create'] = false;
				}
				else {
					this.form['create'] = true;

					// Prepopulate data
					this.form['data']['date'] = this.$moment.utc(new Date()).format('YYYY-MM-DD');
				}

				// Show Dialog
				this.form['show'] = true;
			},
			hideForm() {
				// Hide dialog
				this.form['show'] = false;

				// Unset loading
				this.form['loading'] = false;

				// Clear form
				this.resetForm();
			},
			submitForm() {
				if (this.form['create']) {
					// TODO: Add create product API
					console.log(this.form['data']);

					// Set loading
					this.form['loading'] = true;
				}
				else {
					// TODO: Add edit product API
					console.log(this.form['data']);

					// Set loading
					this.form['loading'] = true;
				}
				setTimeout(() => {
					// Hide dialog
					this.hideForm();
				}, 3000);
			}
		}
	}
</script>
